module.exports = __webpack_public_path__ + "img/stock4.7297ef81.png";